import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
   root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
   },
   table: {
      minWidth: 700,
   },
   removeIconTableCell: {
      width: 100 + "px"
   },
   removeIconContainer: {
      cursor: "pointer",
      padding: 5 + "px"
   },
   tableContainer: {
     // maxWidth: 700,
      //backgroundColor: "#f2f6ff"
   }
});

class TerminalDetails extends React.Component {

  
  render() {
    const { classes, terminal } = this.props;
    
      return (
         <div className={classes.tableContainer}>
            <Table className={classes.table}>
               <TableHead>
                  <TableRow style={{backgroundColor: '#f9f9f9'}}>
                     <TableCell>Type</TableCell>
                     <TableCell>Serial Number</TableCell>
                     <TableCell>Status</TableCell>
                     <TableCell>Comment</TableCell>
                     <TableCell></TableCell>
                     <TableCell></TableCell>
                     <TableCell></TableCell>
                  </TableRow>

               </TableHead>
               <TableBody>
                  {terminal.parts != null && terminal.parts.map(p => {
                     return (
                        <TableRow key={p.id}>
                           <TableCell>{p.partType}</TableCell>
                           <TableCell>{p.serialNum}</TableCell>
                           <TableCell>{p.status}</TableCell>
                           <TableCell colSpan="4">{p.comment}</TableCell>

                        </TableRow>
               )})}
               </TableBody>

            </Table>
         </div>
      );
   }
}

export default withStyles(styles)(TerminalDetails);


// WEBPACK FOOTER //
// ./src/components/Terminals/TerminalDetails.js